export function checkSelection(event: KeyboardEvent): boolean {
  const modifier = event.ctrlKey || event.metaKey;
  const combination = modifier && (event.code === 'KeyA' || event.code === 'KeyC');
  const selection = !window.getSelection()!.isCollapsed;

  return combination && selection;
}
